<template>
  <footer class="footer" :class="{ 'minimal-footer': isCountdownMode }">
    <div v-if="!isCountdownMode" class="footer-top">
      <div class="container">
        <div class="footer-grid">
          <!-- Colonna 1: Assistenza -->
          <div class="footer-column">
            <h3 class="footer-title">{{ t('footer.nav.support.title') }}</h3>
            <ul class="footer-links">
              <li><router-link to="/assistenza?tab=spedizioni">{{ t('footer.nav.support.shipping') }}</router-link></li>
              <li><router-link to="/assistenza?tab=resi">{{ t('footer.nav.support.returns') }}</router-link></li>
              <li><router-link to="/assistenza?tab=pagamenti">{{ t('footer.nav.support.payments') }}</router-link></li>
              <li><router-link to="/assistenza?tab=all">{{ t('footer.nav.support.faq') }}</router-link></li>
            </ul>
          </div>

          <!-- Colonna 2: Brand / Billy B -->
          <div class="footer-column">
            <h3 class="footer-title">{{ t('footer.nav.brand.title') }}</h3>
            <ul class="footer-links">
              <li><router-link to="/chi-siamo">{{ t('footer.nav.brand.about') }}</router-link></li>
              <li><router-link to="/contatti">{{ t('footer.nav.brand.contact') }}</router-link></li>
            </ul>
<ul class="footer-social-links">
  <li>
    <a href="https://instagram.com/billyb.it" target="_blank" rel="noopener noreferrer" class="footer-social-link" aria-label="Instagram">
      <span class="social-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <linearGradient id="insta-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#feda75"/>
            <stop offset="30%" stop-color="#fa7e1e"/>
            <stop offset="55%" stop-color="#d62976"/>
            <stop offset="75%" stop-color="#962fbf"/>
            <stop offset="100%" stop-color="#4f5bd5"/>
          </linearGradient>
          <rect x="2" y="2" width="20" height="20" rx="6" fill="url(#insta-grad)"/>
          <path d="M16 7h1a2 2 0 0 1 2 2v1" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="7" y="7" width="10" height="10" rx="3" fill="none" stroke="#fff" stroke-width="1.6"/>
          <circle cx="12" cy="12" r="2.5" fill="none" stroke="#fff" stroke-width="1.6"/>
        </svg>
      </span>
      Instagram
    </a>
  </li>
  <li>
    <a href="https://tiktok.com/@billyb.it" target="_blank" rel="noopener noreferrer" class="footer-social-link" aria-label="TikTok">
      <span class="social-icon social-icon--tiktok">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <rect x="2" y="2" width="20" height="20" rx="5" fill="#000000"/>
          <path d="M16.6 8.2c-.8-.5-1.4-1.2-1.7-2.1h-2.3v10.1c0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3.3 0 .6.1.9.2V11.8c-.3-.1-.6-.1-.9-.1-2.6 0-4.6 2.1-4.6 4.6s2.1 4.6 4.6 4.6 4.6-2.1 4.6-4.6V10.2c1.1.8 2.4 1.2 3.7 1.2V9.1c-.8 0-1.5-.3-2.0-.9z" fill="#ffffff"/>
        </svg>
      </span>
      TikTok
    </a>
  </li>
  <li>
    <a href="https://www.facebook.com/share/18npytBQjN/" target="_blank" rel="noopener noreferrer" class="footer-social-link" aria-label="Facebook">
      <span class="social-icon social-icon--blue">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <rect x="2" y="2" width="20" height="20" rx="4" fill="#1877f2"/>
          <path d="M13.5 8h1.8l.3-2.2h-2.1c-2 0-2.9 1.3-2.9 2.7V10H8.5v2.7h1.6V18h2.7v-5.3h1.9l.3-2.7h-2.2V9.8c0-.7.2-1.3 1.4-1.3Z" fill="#fff"/>
        </svg>
      </span>
      Facebook
    </a>
  </li>
</ul>
          </div>

          <!-- Colonna 3: Legale -->
          <div class="footer-column">
            <h3 class="footer-title">{{ t('footer.nav.legal.title') }}</h3>
            <ul class="footer-links">
              <li><router-link to="/termini-condizioni">{{ t('footer.nav.legal.terms') }}</router-link></li>
              <li><router-link to="/privacy-policy">{{ t('footer.nav.legal.privacy') }}</router-link></li>
              <li><router-link to="/cookie-policy">{{ t('footer.nav.legal.cookie') }}</router-link></li>
              <li><a href="#" @click.prevent="openCookieBanner">{{ t('footer.nav.legal.cookie_manage') }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <div class="footer-bottom-content">
          <template v-if="!isCountdownMode">
            <p class="footer-copy">{{ t('footer.copyright') }}</p>
            <p class="footer-info">{{ t('footer.legal_info.vat') }}</p>
            <p class="footer-info">
              {{ t('footer.legal_info.registration', { rea: reaNumber }) }}
            </p>
          </template>
          <template v-else>
            <p class="footer-copy desktop-only">{{ t('footer.copyright') }}</p>
            <p class="footer-info desktop-only">{{ t('footer.legal_info.vat') }}</p>
            <p class="footer-info desktop-only">
              {{ t('footer.legal_info.registration', { rea: reaNumber }) }} — 
              <a href="#" @click.prevent="openCookieBanner" class="cookie-link-inline">{{ t('footer.nav.legal.cookie_manage') }}</a>
            </p>
            <p class="footer-info-short mobile-only">
              {{ t('footer.legal_info.legal_short') }} — 
              <a href="#" @click.prevent="openCookieBanner" class="cookie-link-inline">{{ t('footer.nav.legal.cookie_manage') }}</a>
            </p>
          </template>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue'
import { useCookieStore } from '@/stores/useCookieStore'
import { useLanguage } from '@/composables/useLanguage'

const props = defineProps({
  isCountdownMode: {
    type: Boolean,
    default: false
  }
})

const cookieStore = useCookieStore()
const { t } = useLanguage()
const reaNumber = ref('MI-2797326')

const openCookieBanner = () => {
  cookieStore.showBanner = true
}
</script>

<style scoped>
.footer {
  background-color: #000;
  border-top: 1px solid #333;
  margin-top: 0;
  position: relative;
  z-index: 100; /* Assicura che il footer sia sopra la texture di sfondo */
}

.footer.minimal-footer {
  border-top: none;
}

.footer-top {
  padding: 40px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
}

.footer-column {
  display: flex;
  flex-direction: column;
}

.footer-title {
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 15px;
}

.footer-links,
.footer-social-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-social-links {
  margin-top: 18px;
}

.footer-links a,
.footer-social-link {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.footer-social-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
}

.footer-social-link:hover {
  color: var(--bright-teal);
}

.social-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.instagram-icon,
.social-icon--tiktok,
.social-icon--blue {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.instagram-icon svg,
.social-icon--tiktok svg,
.social-icon--blue svg {
  width: 20px;
  height: 20px;
}

.footer-links a:hover {
  color: var(--bright-teal);
  transform: translateX(5px);
}

.footer-bottom {
  background-color: #1a1a1a;
  padding: 30px 0;
  border-top: 1px solid #333;
}

.minimal-footer .footer-bottom {
  background-color: #000000; /* Solid black per coprire la texture */
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
}

.footer-copy,
.footer-info {
  color: #999;
  font-size: 13px;
  letter-spacing: 0.5px;
  margin: 0;
}

.cookie-link-inline {
  color: #666;
  text-decoration: underline;
  transition: color 0.3s ease;
  cursor: pointer;
  margin-left: 2px;
}

.cookie-link-inline:hover {
  color: var(--bright-teal);
}

.footer-copy {
  color: var(--light);
  font-weight: 500;
}

/* .desktop-only / .mobile-only gestite globalmente in App.vue */

@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .container {
    padding: 0 20px;
    padding-left: calc(20px + env(safe-area-inset-left));
    padding-right: calc(20px + env(safe-area-inset-right));
  }

  .footer-top {
    padding: 30px 0;
  }

  .footer-bottom {
    padding: 20px 0;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
  }

  .footer-bottom-content {
    gap: 5px;
  }

  .footer-copy,
  .footer-info {
    font-size: 12px;
  }

  .footer-title {
    font-size: 12px;
    margin-bottom: 14px;
    padding-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 16px;
    padding-left: calc(16px + env(safe-area-inset-left));
    padding-right: calc(16px + env(safe-area-inset-right));
  }
  .footer-top {
    padding: 24px 0;
  }
  .footer-column {
    text-align: left;
  }
  .footer-links a,
  .footer-social-link {
    font-size: 12px;
  }
}

/* Stile per il footer short (mobile) in countdown mode */
.minimal-footer .footer-info-short {
  font-size: 10px;
  font-size: 0.65rem;
  opacity: 0.8;
  color: #ffffff !important;
  margin: 0;
  line-height: 1.4;
  font-weight: 500;
  text-align: center;
  width: 100%;
  display: none; /* Nascosto di default su schermi grandi */
}

@media (max-height: 680px) {
  .minimal-footer .footer-bottom {
    padding: 10px 0;
  }
  .minimal-footer .footer-bottom-content {
    gap: 2px;
  }
  .minimal-footer .footer-copy,
  .minimal-footer .footer-info {
    font-size: 0.7rem;
    line-height: 1.2;
  }
}

@media (max-width: 1024px), (max-height: 680px) {
  .minimal-footer .desktop-only {
    display: none !important;
  }
  .minimal-footer .mobile-only,
  .minimal-footer .footer-info-short {
    display: block !important;
  }
}
</style>
